import { Module } from "vuex";
import { RootState } from "@/store/RootState";
import { mutations } from "@/components/sidebar/store/mutations";
import { getters } from "@/components/sidebar/store/getters";
import { actions } from "@/components/sidebar/store/actions";
import { SideBarState } from "@/components/sidebar/types";

export const state: SideBarState = {
  sideBarOpen: false,
  appMenuItems: []
};

export const sideBar: Module<SideBarState, RootState> = {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
};
